export default "__VITE_ASSET__Bq7wO0b1__"